import {
  Badge,
  Button,
  Card,
  Col,
  Form,
  Icon,
  Input,
  notification,
  Row,
  Switch,
  Table,
  Tooltip
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { getPushPathWrapper } from '../../../routes'
import { connect } from 'react-redux'
import { FormUtils, TableComp } from 'sz-react-utils-lite'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { DisplayDate } from '../../../components/_utils/appUtils'
import Request from '../../../request'
import { getAllAbstracts } from '../views/actions'
import AbstractActivityList from '../views/AbstractActivityList'
import AbstractFilters from './abstractPages/AbstractFilters';
import { SelectAbstractReviewer } from './reviewer/SelectAbstractReviewer';


@Form.create()
class UnderProcessAbstracts extends Component {
  state = {
    filters: {},
    ids: {},
    visibleSelectReview: false,
    abstract: {},
    visibleActivityList: false,
    total: ''
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      let { dispatch } = this.props
      let obj = {
        ...params,
        ...this.state.filters,
        status: 'Abstract Under Process'
      }
      let data = await dispatch(getAllAbstracts(obj))
      this.setState({ total: data.total })
      resolve(data)
    })
  }
  reload = () => {
    this.table.current.reload()
  }

  events = {
    showDrawer: abstract => {
      let ids = {}
      _.each(abstract.selectedReviewer, value => {
        if (value.reviewerId && value.reviewerId._id) {
          ids[value.reviewerId._id] = true
        }
      })
      this.setState({ ids, visibleSelectReview: true, abstract })
    },
    hideDrawer: () => {
      this.setState({ ids: {}, visibleSelectReview: false, abstract: {} }, () => {
        this.reload()
      })
    }
  }

  reloadTable = data => {
    this.setState({ filters: data }, () => {
      this.reload()
    })
  }

  render() {
    const { visibleSelectReview, ids, abstract } = this.state

    const columns = [
      {
        key: 'actions',
        width: 150,
        render: (val, record) => (
          <React.Fragment>
            <Button
              className="roundSmallBtn"
              onClick={() => {
                this.props.dispatch(
                  getPushPathWrapper('onlineAbstractsGroup.viewAbstract', {
                    id: record._id
                  })
                )
              }}
            >
              View Details
            </Button>
            <Button className="roundSmallBtn" onClick={() => this.events.showDrawer(record)}>Select Reviewer</Button>
            <Button className="roundSmallBtn" onClick={() => this.setState({ visibleActivityList: true, abstract: record })}>Activities</Button>
          </React.Fragment>
        )
      },
      { title: 'Submitted Date', key: 'createdAt', dataIndex: 'createdAt', render: item => DisplayDate(item) },
      { title: 'Abstract Id', key: 'onlineAbstractId', dataIndex: 'onlineAbstractId' },
      { title: 'Title', key: 'titleOfAbstract', dataIndex: 'titleOfAbstract', render: item => ReactHtmlParser(item) },
      { title: 'Research Area', key: 'researchArea', dataIndex: 'researchArea' },
      { title: 'Author Name', key: 'authorName', dataIndex: 'authorName' },
      { title: 'Country', key: 'country', dataIndex: 'country' }
    ]

    return (
      <PageHeaderWrapper title={`Under Process Abstracts (${this.state.total})`}>
        <Card bordered={true}>
          <AbstractFilters
            callback={data => {
              this.reloadTable(data)
            }}
          />
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
          />
        </Card>
        {visibleSelectReview ? (
          <SelectAbstractReviewer
            abstract={abstract}
            ids={ids}
            onClose={() => this.events.hideDrawer()}
            visible={visibleSelectReview}
          />
        ) : null}
        {this.state.visibleActivityList && (
          <AbstractActivityList
            abstractId={abstract._id}
            abstractIdNo={abstract.onlineAbstractId}
            visible={this.state.visibleActivityList}
            onClose={() => this.setState({ visibleActivityList: false })}
          />
        )}
      </PageHeaderWrapper>
    )
  }
}

export default connect()(UnderProcessAbstracts)
